const middleware = {}

middleware['applicantOnly'] = require('../middleware/applicantOnly.js')
middleware['applicantOnly'] = middleware['applicantOnly'].default || middleware['applicantOnly']

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['closeSidebarOnSmallDevices'] = require('../middleware/closeSidebarOnSmallDevices.js')
middleware['closeSidebarOnSmallDevices'] = middleware['closeSidebarOnSmallDevices'].default || middleware['closeSidebarOnSmallDevices']

middleware['guest'] = require('../middleware/guest.js')
middleware['guest'] = middleware['guest'].default || middleware['guest']

middleware['isOrganization'] = require('../middleware/isOrganization.js')
middleware['isOrganization'] = middleware['isOrganization'].default || middleware['isOrganization']

middleware['jobOfferContext'] = require('../middleware/jobOfferContext.js')
middleware['jobOfferContext'] = middleware['jobOfferContext'].default || middleware['jobOfferContext']

middleware['organizationOnly'] = require('../middleware/organizationOnly.js')
middleware['organizationOnly'] = middleware['organizationOnly'].default || middleware['organizationOnly']

middleware['outdatedBrowser'] = require('../middleware/outdatedBrowser.js')
middleware['outdatedBrowser'] = middleware['outdatedBrowser'].default || middleware['outdatedBrowser']

middleware['redirect'] = require('../middleware/redirect.js')
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

middleware['requiresPaidAccess'] = require('../middleware/requiresPaidAccess.js')
middleware['requiresPaidAccess'] = middleware['requiresPaidAccess'].default || middleware['requiresPaidAccess']

middleware['superuser'] = require('../middleware/superuser.js')
middleware['superuser'] = middleware['superuser'].default || middleware['superuser']

middleware['teamAssessmentContext'] = require('../middleware/teamAssessmentContext.js')
middleware['teamAssessmentContext'] = middleware['teamAssessmentContext'].default || middleware['teamAssessmentContext']

middleware['userSetupComplete'] = require('../middleware/userSetupComplete.js')
middleware['userSetupComplete'] = middleware['userSetupComplete'].default || middleware['userSetupComplete']

middleware['userTypeGuard'] = require('../middleware/userTypeGuard.js')
middleware['userTypeGuard'] = middleware['userTypeGuard'].default || middleware['userTypeGuard']

middleware['verified'] = require('../middleware/verified.js')
middleware['verified'] = middleware['verified'].default || middleware['verified']

export default middleware
